/**
 * 向前兼容，内置四种语言包
 */
import { __assign } from "tslib";
/* eslint-disable */
import zh_CN from "./locale/zh_CN";
import en_US from "./locale/en_US";
import ja_JP from "./locale/ja_JP";
import ko_KR from "./locale/ko_KR";
export var translationMap = {
    zh_CN: zh_CN,
    zh: zh_CN,
    en_US: __assign(__assign({}, zh_CN), en_US),
    en: __assign(__assign({}, zh_CN), en_US),
    ja: __assign(__assign(__assign({}, zh_CN), en_US), ja_JP),
    jp: __assign(__assign(__assign({}, zh_CN), en_US), ja_JP),
    ko: __assign(__assign(__assign({}, zh_CN), en_US), ko_KR),
};
/* eslint-enable */
//# sourceMappingURL=translationMap.js.map